<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
              {{ detail.order_master ? detail.order_master.orderNo : '暂无' }}
            </div>
          </el-col>
          <el-col :span="19">
            <div class="pb16">
              <span class="gray9">退款说明：</span>
              {{ detail.param ? detail.param.status_text : '暂无' }}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单状态：</span>
              <span style="color:green">
                {{ detail.type ? detail.type.text : '' }}
              </span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">实付款金额 (元)：</span>
              <span style="color:red">
                ￥ {{ detail.order_master ? detail.order_master.pay_price : '0.00' }}元
              </span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">支付方式：</span>
              <span style="color:orange">
                {{ detail.order_master ? detail.order_master.pay_type.text : '' }}
              </span>

            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">下单时间：</span>
              {{ detail.createTime }}
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="table-wrap">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="订单信息" name="order"></el-tab-pane>
          <el-tab-pane label="项目信息" name="project"></el-tab-pane>
          <el-tab-pane label="加钟信息" name="bell"></el-tab-pane>
          <el-tab-pane label="订单明细" name="detail"></el-tab-pane>
          <el-tab-pane label="订单记录" name="record"></el-tab-pane>
          <el-tab-pane label="服务信息" name="service"></el-tab-pane>
          <el-tab-pane label="技师报备" name="report"></el-tab-pane>

        </el-tabs>
        <div>
          <Order v-show="activeName == 'order'" :detail='detail'></Order>
          <Project v-show="activeName == 'project'" :detail='detail'></Project>
          <Bell v-show="activeName == 'bell'" :detail='detail'></Bell>
          <Detail v-show="activeName == 'detail'" :detail='detail'></Detail>
          <Record v-show="activeName == 'record'" :detail='detail'></Record>
          <Service v-show="activeName == 'service'" :detail='detail'></Service>
          <Report v-show="activeName == 'report'" :detail='detail'></Report>

        </div>
      </div>
    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
      <el-button v-if="detail.is_agree" :disabled="detail.is_agree.value == 10"
      @click="agreeclick(detail,detail.param, detail.orderId)" type="primary" size="small">退款审核</el-button>
      <!--用户取消-->
      <!-- <template v-if="detail.pay_status &&detail.pay_status.value == 20 && detail.order_status.value == 21">
        <el-button size="small" type="primary" @click="confirmCancel(1)">审核通过</el-button>
      </template>
      <template v-if=" detail.pay_status &&detail.pay_status.value == 20 && detail.order_status.value == 21">
        <el-button size="small" type="primary" @click="confirmCancel(0)">审核拒绝</el-button>
      </template> -->
    </div>
    <!--审核-->
    <Examine v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')">
    </Examine>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import Examine from "./examine";
import Bell from "./part/bell.vue";
import Order from "./part/order.vue";
import Detail from "./part/detail.vue";
import Project from "./part/project.vue";
import Record from "./part/record.vue";
import Service from "./part/service.vue";
import Report from "./part/report.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    Examine,
    Bell,
    Order,
    Detail,
    Project,
    Record,
    Service,
    Report,
  },
  data() {
    return {
      detail: {},
      // 技师是否显示
      isModify: false,
      active: 0,
      activeName: "order",
      /*是否加载完成*/
      loading: true,
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*发货*/
      form: {
        /*订单ID*/
        express_id: null,
        /*订单号*/
        express_no: ""
      },
      forms: {
        is_cancel: 1
      },
      extract_form: {
        order: {
          extract_status: 1
        }
      },
      order: {},
      delivery_type: 0,
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*当前编辑的对象*/
      userModel: {
        order_refund_id: "",
        params: ""
      },
      /*时间*/
      createTime: "",
      /*快递公司列表*/
      expressList: [],
      reportData: [],
      shopClerkList: [],
      /*是否打开编辑弹窗*/
      open_edit: false,
      isChange: false,
      addressData: {
        name: "",
        phone: "",
        region: {
          province: "",
          province_id: 0,
          city: "",
          city_id: 0,
          region: "",
          region_id: 0,
          detail: "",
          username: ""
        }
      },
      uses: "",
      user_id: ""
    };
  },
  created(e) {
    /*获取列表*/
    this.getParams();
  },
  methods: {
    next() {
      if (this.active++ > 4) this.active = 0;
    },
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.order_refund_id;
      OrderApi.refundDetail({ order_refund_id: params }, true)
        .then(data => {
          self.loading = false;
          // self.alldetail = data.data.detail;
          self.detail = data.data.detail;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开审核*/
    agreeclick(detail,params, id) {
      // this.userModel.order_refund_id = this.$route.query.order_refund_id;
      // this.userModel.params = params;
      // console.log("============", this.userModel);
      // this.open_edit = true;
      console.log(detail)
      this.userModel.order_refund_id = this.$route.query.order_refund_id;
      this.userModel.params = params;
      this.userModel.order_master = detail.order_master;
      console.log("============", this.userModel);
      this.open_edit = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          // this.getData();
          this.$message({
            message: "恭喜你，审核成功",
            type: "success"
          });
          this.getParams();
        }
      }
    },
    /*确认取消*/
    confirmCancel(e) {
      let self = this;
      let orderId = this.$route.query.orderId;
      let is_cancel = e;
      OrderApi.confirm(
        {
          orderId: orderId,
          is_cancel: is_cancel
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，审核成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    changeAdd() {
      this.isChange = true;
    },
    closeAddress(e) {
      let self = this;
      if (e == false) {
        self.isChange = false;
        console.log(e);
        return false;
      }
      let params = e.params;
      console.log(params);
      params.orderId = self.$route.query.orderId;
      OrderApi.updateAddress(params, true)
        .then(data => {
          self.$message({
            message: "修改成功",
            type: "success"
          });
        })
        .catch(error => { });
      self.isChange = false;
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/refund/detail.vue